import { useEffect, useRef, useState } from "react";
import ASSET_PATHS from "../../../assets/config/assetPaths";
import {
  IoIosArrowBack,
  IoIosArrowDown,
  IoIosArrowForward,
  IoIosArrowUp,
  IoIosClose,
} from "react-icons/io";
import { AppDispatch, RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  fetchPresignedUrl,
  updateInspectionPoint,
  updateInpectionPointAndStartWorkOrder,
  updatePhotoUrl,
  updateModuleAndStartWorkOrder,
} from "../../../redux/slices/inspectionSlice";
import { ImSpinner2 } from "react-icons/im";
import PreviewImageUploadModal from "../../../components/template/Modal/PreviewImageUpload";
import {
  // blobToBase64,
  compressImage,
  // compressImage,
  uint8ArrayToBase64,
} from "../../../lib/image-compressor";
import { postMessage } from "../../../lib/post-message";
import { Detail, Image, Section } from "../../../types/inspection";
import {
  isPointCompleted,
  getInspectionPointLimit,
} from "../../../lib/inspectionItems";
import { v4 as uuidv4 } from "uuid";
import { PointType, WorkOrderStatus } from "../../../types/workOrder";
import {
  fetchWorkOrderDetails,
  WorkOrderDetail,
  updateImageCount,
} from "../../../redux/slices/workOrderDetailSlice";
import { showToaster } from "../../../redux/slices/toasterSlice";
import { useNavigate } from "react-router-dom";
import { setItemIdForRedirect } from "../../../redux/slices/redirectSlice";
import PullToRefresh from "react-simple-pull-to-refresh";
import PreviewVideoUploadModal from "../../../components/template/Modal/PreviewVideoUpload";
import { isReallyOnline } from "../../../lib/isOnline";
import UnSkipModuleModal from "../../../components/template/Modal/UnskipModuleModal";
import SkipModuleModal from "../../../components/template/Modal/SkipModuleModal";
import SwipeableModuleContainer from "./SwaipeableModuleContainer";
import { getImage, getIndexDBSettings, getInspectionPointMapping, putImage } from "../../../db";
import AutoResizeTextarea from "../../../components/template/TextArea/AutoResizeTextarea";
import {
  isOfflineMode,
  turnOfflineModeOn,
} from "../../../shared/offlineManager";
import Layout from "../../../components/template/Layout";

const InspectionPoints = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { token, tenant } = useSelector((state: RootState) => state.auth);
  const [isUploadImageModal, setIsUploadImageModal] = useState(false);

  const [answerInputValues, setAnswerInputValues] = useState<
    Record<number, string>
  >({});
  const [commentValue, setCommentValue] = useState<string | null>(null);
  const [crossValues, setCrossValues] = useState<Record<number, string>>({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [elementControlId, setelementControlId] = useState<string>("");
  const [isCameraSelected, setIsCameraSelected] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);
  const [shouldTriggerImageUpload, setShouldTriggerImageUpload] =
    useState(false);
  const { itemIdForRedirect, oldId } = useSelector(
    (state: RootState) => state.redirect
  );
  const { workOrderDetail } = useSelector(
    (state: RootState) => state.workOrderDetail
  );
  const { assetId, workOrderId } = useParams<{
    workOrderId: string;
    assetId: string;
  }>();
  const asset_ID = assetId ? parseInt(assetId) : 0;
  const itemDetail = (
    workOrderDetail[+workOrderId!]?.items as WorkOrderDetail[]
  )?.find((workOrder) => workOrder.item_ID === asset_ID);
  const [showIcons, setShowIcons] = useState<boolean[]>([]);
  const [isSkipModuleModalOpen, setIsSkipModuleModalOpen] = useState(false);
  const [isUnSkipModuleModalOpen, setIsUnSkipModuleModalOpen] = useState(false);
  const [selectedModule, setSelectedModule] = useState<Section | null>(null);
  const [selectedModuleIndex, setSelectedModuleIndex] = useState<number | null>(
    null
  );

  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState<Image[]>([]);
  const [uploadedImage, setUploadedImage] = useState<string[] | []>([]);
  const [uploadedVideo, setUploadedVideo] = useState<string[]>([]);
  const [selectedFiles, setSelectedFiles] = useState<File[] | []>([]);
  const [isUploadVideoModal, setIsUploadVideoModal] = useState(false);
  const [currentCapturedDetail, setCurrentCapturedDetail] = useState<{
    sectionIndex: number;
    detailIndex: number;
    detail: any;
  } | null>(null);

  const [resolvedImageURLs, setResolvedImageURLs] = useState<{
    [uuid: string]: string;
  }>({});

  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  const modalRef = useRef<HTMLDivElement | null>(null);

  const contentRefs = useRef<(HTMLDivElement | null)[]>([]);

  const navigate = useNavigate();

  useEffect(() => {
    if (itemIdForRedirect && oldId && oldId === asset_ID && workOrderId) {
      navigate(`/work-orders/${workOrderId}/inspection/${itemIdForRedirect}`);
      dispatch(setItemIdForRedirect({ itemIdForRedirect: null, oldId: null })); // Reset after navigating
    }
  }, [itemIdForRedirect, oldId, asset_ID, workOrderId, navigate, dispatch]);

  useEffect(() => {
    const imageElementId = localStorage.getItem("elementControlId");
    if (imageElementId) {
      setelementControlId(imageElementId);
    }
    if (navigator.userAgent.toLowerCase().includes("android")) {
      setIsAndroid(true);
    }
  }, []);

  useEffect(() => {
    if (shouldTriggerImageUpload) {
      const imageElementId =
        elementControlId || localStorage.getItem("elementControlId") || "";
      document.getElementById(imageElementId)?.click();
      setShouldTriggerImageUpload(false); // Reset the trigger
    }
  }, [shouldTriggerImageUpload]);

  useEffect(() => {
    const loadUrls = async () => {
      const newUrls: Record<string, string> = {};
      const visited = new Set<string>();

      for (const module of itemDetail?.modules || []) {
        for (const point of module.points || []) {
          for (const photo of point.photos || []) {
            if (
              photo.type === "image" &&
              photo.uuid &&
              !resolvedImageURLs[photo.uuid] &&
              !visited.has(photo.uuid)
            ) {
              visited.add(photo.uuid);
              try {
                const imageResult = await getImage(photo.uuid);
                const blob = imageResult?.blob;
                if (blob) {
                  newUrls[photo.uuid] = URL.createObjectURL(blob);
                } else if (photo.url) {
                  newUrls[photo.uuid] = photo.url;
                }
              } catch (e) {
                if (photo.url) {
                  newUrls[photo.uuid] = photo.url;
                }
                console.warn(
                  `Failed to resolve image for UUID ${photo.uuid}`,
                  e
                );
              }
            }
          }
        }
      }

      if (Object.keys(newUrls).length > 0) {
        setResolvedImageURLs((prev) => ({ ...prev, ...newUrls }));
      }
    };

    loadUrls();
  }, [itemDetail]);

  const generateGuid = () => {
    return uuidv4();
  };

  const openModal = (inputId: string) => {
    let finalId = inputId?.trim();
    if (!finalId) {
      finalId = localStorage.getItem("elementControlId") || "";
    }
    if (isAndroid) {
      setIsModalOpen(true);
      setelementControlId(finalId);
      localStorage.setItem("elementControlId", finalId);
    } else {
      setelementControlId(finalId);
      document.getElementById(`${finalId}`)?.click();
      localStorage.setItem("elementControlId", finalId);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const toggleSection = (index: number) => {
    const updatedSection = itemDetail?.modules[index];

    if (updatedSection) {
      const updatedSectionData = {
        ...updatedSection,
        isOpen: !updatedSection.isOpen,
      };
      if (workOrderId)
        dispatch(
          updateModuleAndStartWorkOrder({
            item_ID: asset_ID,
            updatedModule: updatedSectionData,
            sectionIndex: index,
            token,
            workorder_id: +workOrderId,
          })
        );
    }
  };

  const toggleIconSelection = (
    sectionIndex: number,
    detailIndex: number,
    selectedAction: keyof Detail["actions"]
  ) => {
    if (!itemDetail || !workOrderId) return;

    const section = itemDetail.modules[sectionIndex];
    const detail = section?.points[detailIndex];

    if (!section || !detail) {
      console.error("Invalid sectionIndex or detailIndex");
      return;
    }

    const updatedDetail = {
      ...detail,
      answerValue:
        selectedAction === "check"
          ? detail.answerValue === "YES"
            ? ""
            : "YES"
          : selectedAction === "cross"
          ? detail.answerDisplay === "NO"
            ? ""
            : "NO"
          : detail.answerValue,
      isEditing: selectedAction === "edit" ? !detail.isEditing : false,
      isCommenting: selectedAction === "comment" ? !detail.isCommenting : false,
      answerDisplay:
        selectedAction === "check"
          ? detail.answerValue === "YES"
            ? ""
            : detail.type_ID === 4
            ? "YES"
            : detail.verify
          : selectedAction === "cross"
          ? detail.answerValue === "NO"
            ? ""
            : "NO"
          : detail.answerDisplay,
      isCrossing:
        selectedAction === "cross" && detail.type_ID === 5
          ? !detail.isCrossing
          : false,
      isChecking: selectedAction === "check" ? !detail.isChecking : false,
      isGalleryVisible:
        selectedAction === "gallery" ? !detail.isGalleryVisible : false,
      actions: Object.keys(detail.actions).reduce((newActions, action) => {
        newActions[action] = {
          ...detail.actions[action],
          isSelected:
            action === selectedAction
              ? !detail.actions[action].isSelected
              : false,
        };
        return newActions;
      }, {} as Detail["actions"]),
    };

    dispatch(
      updateInpectionPointAndStartWorkOrder({
        item_ID: asset_ID,
        updatePoint: { ...updatedDetail },
        sectionIndex,
        token,
        workorder_id: +workOrderId,
      })
    );
  };

  const handleCloseUploadVideoModal = () => {
    setIsUploadVideoModal(false);
    setUploadedVideo([]);
    setSelectedFiles([]);
  };

  const handleCancel = (
    sectionIndex: number,
    detailIndex: number,
    selectedAction: keyof Detail["actions"]
  ) => {
    if (!itemDetail || !workOrderId) return;

    const section = itemDetail.modules[sectionIndex];
    const point = section?.points?.[detailIndex];

    if (!section || !point) return;

    const updatedPoint = {
      ...point,
      isCrossing: false,
      actions: Object.keys(point.actions).reduce((newActions, action) => {
        newActions[action] = {
          ...point.actions[action],
          isSelected:
            action === selectedAction
              ? !point.actions[action].isSelected
              : false,
        };
        return newActions;
      }, {} as Detail["actions"]),
    };

    resetCrossValue(point.id);

    dispatch(
      updateInpectionPointAndStartWorkOrder({
        item_ID: asset_ID,
        updatePoint: updatedPoint,
        sectionIndex,
        token,
        workorder_id: +workOrderId,
      })
    );
  };

  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement> | Event,
    type: string
  ) => {
    try {
      const input = event.target as HTMLInputElement;
      const files = input.files;
      const validFiles: File[] = [];
      const fileURLs: string[] = [];
      if (files != null && files?.length > 0) {
        for (const file of Array.from(files)) {
          const fileExtension = file.name.split(".").pop()?.toLowerCase();
          const allowedExtensions =
            type === "video" ? ["mp4", "mov"] : ["png", "jpeg", "jpg"];
          const allowedTypes =
            type === "video"
              ? ["video/mp4", "video/quicktime"]
              : ["image/png", "image/jpeg"];

          if (
            fileExtension &&
            allowedExtensions.includes(fileExtension) &&
            allowedTypes.includes(file.type)
          ) {
            validFiles.push(file);
            if (type === "video") {
              fileURLs.push(URL.createObjectURL(file));
            }
          } else {
            dispatch(
              showToaster({
                message: `Invalid ${type} file type.`,
                type: "error",
              })
            );
          }
        }
        if (type === "image") {
          const imagePromises = validFiles.map((file) => {
            return new Promise<string>((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result as string);
              reader.onerror = () => reject(new Error("File read error"));
              reader.readAsDataURL(file);
            });
          });
          const uploadedImages = await Promise.all(imagePromises);
          setSelectedFiles((prevState) => [...prevState, ...validFiles]);
          setUploadedImage((prevState) => [...prevState, ...uploadedImages]);
          setIsUploadImageModal(true);
        } else if (type === "video") {
          const uploadedVideosUrl = validFiles.map(
            (_, index) => fileURLs[index]
          );
          setSelectedFiles((prevState) => [...prevState, ...validFiles]);
          setUploadedVideo((prevState) => [...prevState, ...uploadedVideosUrl]);
          setIsUploadVideoModal(true);
        }
      }
    } catch (e) {
      console.error("Error reading files:", e);
      dispatch(
        showToaster({
          message: "An error occurred while reading the files.",
          type: "error",
        })
      );
    } finally {
      const input = event.target as HTMLInputElement;
      if (input) {
        input.value = "";
      }
    }
  };

  const handleSave = async ({
    sectionIndex,
    detailIndex,
    pointId,
    type,
  }: {
    sectionIndex: number;
    detailIndex: number;
    pointId: number;
    type: "edit" | "comment" | "cross";
  }) => {
    if (!itemDetail || !workOrderId) return;

    const detail = itemDetail.modules[sectionIndex]?.points[detailIndex];
    const section = itemDetail.modules[sectionIndex];
    if (!detail || !section) return;

    const data = {
      ...(type === "edit"
        ? {
            answerValue: answerInputValues[detail.id] || "",
            answerDisplay: answerInputValues[detail.id] || "",
          }
        : type === "comment"
        ? { answerComment: commentValue }
        : detail.type_ID === 4
        ? { answerValue: "NO", answerDisplay: "NO" }
        : {
            answerValue: crossValues[detail.id] ? "NO" : "",
            answerDisplay: crossValues[detail.id] || "",
          }),
      metaData: {
        workOrderId: workOrderId,
        assetId: asset_ID,
        pointId: pointId,
        label: detail.label,
        module: section.title,
        description: `input failed: '${
          answerInputValues[detail.id] || crossValues[detail.id] || "N/A"
        }'.`,
      },
    };

    const updatedPoint = {
      ...detail,
      isSaving: true,
    };

    dispatch(
      updateInpectionPointAndStartWorkOrder({
        item_ID: asset_ID,
        updatePoint: updatedPoint,
        sectionIndex,
        token,
        workorder_id: +workOrderId,
      })
    );

    dispatch(
      updateInspectionPoint({
        token,
        inspection_pont_id: pointId,
        workorder_id: +workOrderId,
        data,
      })
    );

    const updatedDetail = {
      ...updatedPoint,
      answerValue:
        type === "edit"
          ? answerInputValues[detail.id] || ""
          : type === "cross"
          ? "NO"
          : detail.answerValue,
      isEditing: type === "edit" ? false : detail.isEditing,
      isCommenting: type === "comment" ? false : detail.isCommenting,
      answerDisplay:
        type === "cross"
          ? detail.type_ID === 4
            ? "NO"
            : crossValues[detail.id]
            ? crossValues[detail.id]
            : ""
          : detail.answerDisplay,
      isCrossing: type === "cross" ? false : detail.isCrossing,
      isSaving: false,
      actions: Object.keys(detail.actions).reduce((newActions, action) => {
        newActions[action] = {
          ...detail.actions[action],
          isSelected: false,
        };
        return newActions;
      }, {} as Detail["actions"]),
    };

    dispatch(
      updateInpectionPointAndStartWorkOrder({
        item_ID: asset_ID,
        updatePoint: { ...updatedDetail },
        sectionIndex,
        token,
        workorder_id: +workOrderId,
      })
    );

    setCrossValues((prev) => ({
      ...prev,
      [detail.id]: "",
    }));
    setCommentValue(null);
  };

  const handleCheck = async ({
    sectionIndex,
    detailIndex,
    pointId,
  }: {
    sectionIndex: number;
    detailIndex: number;
    pointId: number;
  }) => {
    const detail =
      itemDetail && itemDetail.modules[sectionIndex].points[detailIndex];
    const section = itemDetail?.modules[sectionIndex];
    const data = {
      ...(detail.answerValue === "YES"
        ? { answerValue: "", answerDisplay: "" }
        : detail.type_ID === 4
        ? { answerValue: "YES", answerDisplay: "YES" }
        : { answerValue: "YES", answerDisplay: detail.verify }),
      metaData: {
        workOrderId: workOrderId,
        assetId: asset_ID,
        module: section.title,
        pointId: pointId,
        label: detail.label,
        description: `verify failed`,
      },
    };
    if (workOrderId) {
      dispatch(
        updateInspectionPoint({
          workorder_id: +workOrderId,
          token,
          inspection_pont_id: pointId,
          data,
        })
      );

      toggleIconSelection(sectionIndex, detailIndex, "check");
    }
  };

  const handleCross = async ({
    sectionIndex,
    detailIndex,
    pointId,
  }: {
    sectionIndex: number;
    detailIndex: number;
    pointId: number;
  }) => {
    const detail =
      itemDetail && itemDetail.modules[sectionIndex].points[detailIndex];
    const section = itemDetail?.modules[sectionIndex];
    const data = {
      ...(detail.answerDisplay === "NO"
        ? { answerValue: "", answerDisplay: "" }
        : { answerValue: "NO", answerDisplay: "NO" }),
      metaData: {
        workOrderId: workOrderId,
        assetId: asset_ID,
        module: section.title,
        pointId: pointId,
        label: detail.label,
        description: `cross failed`,
      },
    };
    if (workOrderId) {
      dispatch(
        updateInspectionPoint({
          workorder_id: +workOrderId,
          token,
          inspection_pont_id: pointId,
          data,
        })
      );
      toggleIconSelection(sectionIndex, detailIndex, "cross");
    }
  };

  useEffect(() => {
    itemDetail?.modules.forEach((section: Section, index: number) => {
      if (section.isOpen && contentRefs.current[index]) {
        contentRefs.current[index]!.style.maxHeight = "100%";
      } else if (contentRefs.current[index]) {
        contentRefs.current[index]!.style.maxHeight = "0px";
      }
    });
  }, [workOrderDetail]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        setIsPreviewModalOpen(false);
      }
    };

    if (isPreviewModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPreviewModalOpen]);

  const toggleEdit = (sectionIndex: number, detailIndex: number) => {
    if (!itemDetail || !workOrderId) return;

    const detail = itemDetail.modules[sectionIndex]?.points[detailIndex];
    if (!detail) return;

    setAnswerInputValues((prev) => ({
      ...prev,
      [detail.id]: detail.answerValue,
    }));

    const updatedPoint = {
      ...detail,
      isEditing: !detail.isEditing,
      isCommenting: false,
      isGalleryVisible: false,
      isCrossing: false,
      isChecking: false,
      actions: Object.keys(detail.actions).reduce((newActions, action) => {
        newActions[action] = {
          ...detail.actions[action],
          isSelected:
            action === "edit" ? !detail.actions.edit.isSelected : false,
        };
        return newActions;
      }, {} as Detail["actions"]),
    };

    dispatch(
      updateInpectionPointAndStartWorkOrder({
        item_ID: asset_ID,
        updatePoint: updatedPoint,
        sectionIndex,
        token,
        workorder_id: +workOrderId,
      })
    );
  };

  useEffect(() => {
    if (itemDetail?.modules?.length) {
      setShowIcons(new Array(itemDetail.modules.length).fill(false));
    }
  }, [itemDetail]);

  const toggleGallery = (sectionIndex: number, detailIndex: number) => {
    if (!itemDetail || !workOrderId) return;

    const detail = itemDetail.modules[sectionIndex]?.points[detailIndex];
    if (!detail) return;

    const updatedPoint = {
      ...detail,
      isGalleryVisible: !detail.isGalleryVisible,
      isEditing: false,
      isCrossing: false,
      isChecking: false,
      isCommenting: false,
      actions: Object.keys(detail.actions).reduce((newActions, action) => {
        newActions[action] = {
          ...detail.actions[action],
          isSelected:
            action === "gallery" ? !detail.actions.gallery.isSelected : false,
        };
        return newActions;
      }, {} as Detail["actions"]),
    };

    dispatch(
      updateInpectionPointAndStartWorkOrder({
        item_ID: asset_ID,
        updatePoint: updatedPoint,
        sectionIndex,
        token,
        workorder_id: +workOrderId,
        shouldWorkOrderMoveToProgress: false,
      })
    );
  };

  const toggleCross = (sectionIndex: number, detailIndex: number) => {
    if (!itemDetail || !workOrderId) return;

    const detail = itemDetail.modules[sectionIndex]?.points[detailIndex];
    if (!detail) return;

    setAnswerInputValues((prev) => ({
      ...prev,
      [detail.id]: detail.answerValue,
    }));

    const updatedPoint = {
      ...detail,
      isCrossing: !detail.isCrossing,
      isEditing: false,
      isCommenting: false,
      isChecking: false,
      isGalleryVisible: false,
      actions: Object.keys(detail.actions).reduce((newActions, action) => {
        newActions[action] = {
          ...detail.actions[action],
          isSelected:
            action === "cross" ? !detail.actions.cross.isSelected : false,
        };
        return newActions;
      }, {} as Detail["actions"]),
    };

    dispatch(
      updateInpectionPointAndStartWorkOrder({
        item_ID: asset_ID,
        updatePoint: updatedPoint,
        sectionIndex,
        token,
        workorder_id: +workOrderId,
      })
    );
  };

  const toggleComment = (sectionIndex: number, detailIndex: number) => {
    if (!itemDetail || !workOrderId) return;

    const detail = itemDetail.modules[sectionIndex]?.points[detailIndex];
    if (!detail) return;

    const updatedPoint = {
      ...detail,
      isCommenting: !detail.isCommenting,
      isEditing: false,
      isCrossing: false,
      isChecking: false,
      isGalleryVisible: false,
      actions: Object.keys(detail.actions).reduce((newActions, action) => {
        newActions[action] = {
          ...detail.actions[action],
          isSelected:
            action === "comment" ? !detail.actions.comment.isSelected : false,
        };
        return newActions;
      }, {} as Detail["actions"]),
    };

    dispatch(
      updateInpectionPointAndStartWorkOrder({
        item_ID: asset_ID,
        updatePoint: updatedPoint,
        sectionIndex,
        token,
        workorder_id: +workOrderId,
      })
    );
  };

  const handleClosePreviewModal = () => {
    setIsPreviewModalOpen(false);
  };

  const openPreviewModal = (images: Image[], clickedIndex: number) => {
    setCurrentImages(images);
    setCurrentImageIndex(clickedIndex);
    setIsPreviewModalOpen(true);
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % currentImages.length);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex(
      (prevIndex) =>
        (prevIndex - 1 + currentImages.length) % currentImages.length
    );
  };

  const handleRemoveImage = (indexToRemove: number) => {
    const updatedImages = uploadedImage.filter(
      (_, index) => index !== indexToRemove
    );
    setUploadedImage(updatedImages);
    const selected = selectedFiles.filter(
      (_, index) => index !== indexToRemove
    );
    setSelectedFiles(selected);
  };

  const handleSkip = async (sectionIndex: number, detail: any) => {
    if (!workOrderId || !itemDetail) return;
    const section = itemDetail?.modules[sectionIndex];
    const data = {
      notApplicable: true,
      metaData: {
        workOrderId: workOrderId,
        assetId: asset_ID,
        module: section.title,
        pointId: detail.id,
        label: detail.label,
        description: `skip failed`,
      },
    };

    dispatch(
      updateInspectionPoint({
        token,
        inspection_pont_id: detail.id,
        workorder_id: +workOrderId,
        data,
      })
    );

    const updatedPoint = {
      ...detail,
      notApplicable: true,
      answerValue: null,
      answerDisplay: null,
    };

    dispatch(
      updateInpectionPointAndStartWorkOrder({
        item_ID: asset_ID,
        updatePoint: updatedPoint,
        sectionIndex,
        token,
        workorder_id: +workOrderId,
      })
    );
  };

  const handleSkipAll = async (sectionIndex: number) => {
    if (!workOrderId || !itemDetail) return;

    const moduleToSkip = itemDetail.modules[sectionIndex];

    if (!moduleToSkip) {
      console.error("Invalid sectionIndex or module not found");
      return;
    }

    const skipPromises = moduleToSkip.points.map((point: Detail) => {
      const data = {
        notApplicable: true,
        metaData: {
          workOrderId: workOrderId,
          assetId: asset_ID,
          module: moduleToSkip.title,
          pointId: point.id,
          label: point.label,
          description: `skip failed`,
        },
      };
      return dispatch(
        updateInspectionPoint({
          token,
          inspection_pont_id: point.id,
          workorder_id: +workOrderId,
          data,
          shouldNotify: false,
        })
      );
    });

    const results = await Promise.all(skipPromises);

    const allFulfilled = results.every(
      (result) => result.meta.requestStatus === "fulfilled"
    );

    if (allFulfilled) {
      let verifiedCount = moduleToSkip.totalVerified || 0;

      const updatedPoints = moduleToSkip.points.map((point: Detail) => {
        const updatedPoint = {
          ...point,
          notApplicable: true,
          isCompleted: true,
          answerValue: null,
          answerDisplay: null,
        };

        if (!point.isCompleted) {
          verifiedCount++;
        }

        return updatedPoint;
      });

      const isSkipped = updatedPoints.every(
        (point: any) => point.notApplicable === true
      );

      const updatedModule = {
        ...moduleToSkip,
        totalVerified: verifiedCount,
        points: updatedPoints,
        isSkipped,
        isOpen: false,
      };

      dispatch(
        updateModuleAndStartWorkOrder({
          item_ID: asset_ID,
          updatedModule,
          sectionIndex,
          token,
          workorder_id: +workOrderId,
        })
      );
    } else {
      console.error("Failed to update some points in the module");
    }
  };

  const handleUnSkip = async (sectionIndex: number, detail: any) => {
    if (!workOrderId || !itemDetail) return;
    const section = itemDetail?.modules[sectionIndex];
    const data = {
      notApplicable: false,
      metaData: {
        workOrderId: workOrderId,
        assetId: asset_ID,
        module: section.title,
        pointId: detail.id,
        label: detail.label,
        description: `unskip failed`,
      },
    };

    dispatch(
      updateInspectionPoint({
        token,
        inspection_pont_id: detail.id,
        data,
        workorder_id: +workOrderId,
      })
    );

    const updatedPoint = {
      ...detail,
      notApplicable: false,
    };

    dispatch(
      updateInpectionPointAndStartWorkOrder({
        item_ID: asset_ID,
        updatePoint: updatedPoint,
        sectionIndex,
        token,
        workorder_id: +workOrderId,
      })
    );
  };

  const handleUnskipAll = async (sectionIndex: number) => {
    if (!workOrderId || !itemDetail) return;

    const moduleToUnskip = itemDetail.modules[sectionIndex];

    if (!moduleToUnskip) {
      console.error("Invalid sectionIndex or module not found");
      return;
    }

    const unskipPromises = moduleToUnskip.points.map((point: Detail) => {
      const data = {
        notApplicable: false,
        metaData: {
          workOrderId: workOrderId,
          assetId: asset_ID,
          module: moduleToUnskip.title,
          pointId: point.id,
          label: point.label,
          description: `unskip failed`,
        },
      };
      return dispatch(
        updateInspectionPoint({
          token,
          inspection_pont_id: point.id,
          workorder_id: +workOrderId,
          data,
          shouldNotify: false,
        })
      );
    });

    const results = await Promise.all(unskipPromises);

    const allFulfilled = results.every(
      (result) => result.meta.requestStatus === "fulfilled"
    );

    if (allFulfilled) {
      let verifiedCount = moduleToUnskip.totalVerified || 0;

      const updatedPoints = moduleToUnskip.points.map((point: Detail) => {
        let updatedPoint = {
          ...point,
          notApplicable: false,
        };
        const isCompleted = isPointCompleted(updatedPoint, itemDetail.type);
        updatedPoint = {
          ...updatedPoint,
          isCompleted,
        };
        if (!updatedPoint.isCompleted && point.isCompleted) {
          verifiedCount--;
        }

        return updatedPoint;
      });

      const isSkipped = updatedPoints.every(
        (point: any) => point.notApplicable === true
      );

      const updatedModule = {
        ...moduleToUnskip,
        totalVerified: verifiedCount,
        points: updatedPoints,
        isSkipped,
        isOpen: false,
      };

      dispatch(
        updateModuleAndStartWorkOrder({
          item_ID: asset_ID,
          updatedModule,
          sectionIndex,
          token,
          workorder_id: +workOrderId,
        })
      );
    } else {
      console.error("Failed to update some points in the module");
    }
  };

  const handleCloseUploadImageModal = (reset = true) => {
    setIsUploadImageModal(false);
    if (reset) {
      setUploadedImage([]);
      setSelectedFiles([]);
    }
  };

  // Helper method to process images with batching to prevent browser crashes
  // Processing 40+ images concurrently causes memory exhaustion and "Aw, snap!" crashes
  // Batching prevents this by limiting concurrent Web Workers and IndexedDB operations
  const processInspectionImages = async (
    files: File[],
    compressionEnabled: boolean
  ): Promise<{ uuid: string }[]> => {
    // Process one at a time (BATCH_SIZE = 1) to avoid worker kill on Android when notifications arrive
    const BATCH_SIZE = 1;
    
    console.log(`📦 Processing ${files.length} images in batches of ${BATCH_SIZE}`);

    const compressedImages: { uuid: string }[] = [];

    // Process in batches to avoid overwhelming memory with too many Web Workers
    // Each compression creates a Web Worker, and too many concurrent workers cause crashes
    for (let i = 0; i < files.length; i += BATCH_SIZE) {
      const batch = files.slice(i, i + BATCH_SIZE);
      
      // Process batch concurrently
      const batchPromises = batch.map(async (file) => {
        const uuid = generateGuid();
        const compressedBlob = compressionEnabled
          ? await compressImage(file)
          : file;
        await putImage(uuid, compressedBlob);
        return { uuid };
      });

      const batchResults = await Promise.all(batchPromises);
      compressedImages.push(...batchResults);
      
      // Small delay between batches to allow garbage collection and memory recovery
      if (i + BATCH_SIZE < files.length) {
        await new Promise(resolve => setTimeout(resolve, 50));
      }
    }

    return compressedImages;
  };

  const handleUploadedImageProceed = async () => {
    if (currentCapturedDetail) {
      const { sectionIndex, detailIndex, detail } = currentCapturedDetail;
      console.log("Current captured detail:", currentCapturedDetail);
      
      if (selectedFiles.length > 0) {
        try {
          const section = itemDetail?.modules[sectionIndex];
          const compressionEnabled = localStorage.getItem("compressionEnabled")
            ? localStorage.getItem("compressionEnabled") === "yes"
            : true;

          console.log("Compression enabled:", compressionEnabled);

          // Resolve inspection point ID (handle temp IDs)
          let pointId = detail.id;
          if (typeof detail.id === "string") {
            try {
              pointId = await getInspectionPointMapping(detail.id);
            } catch (err) {
              console.error("Unexpected error getting point mapping:", err);
            }
          }

          // Compress and store images in IndexedDB using concurrent processing
          const compressedImages = await processInspectionImages(
            selectedFiles,
            compressionEnabled
          );

          // Update Redux immediately - show images in gallery
          const point = section?.points[detailIndex];
          if (!section || !point) {
            console.error("Invalid sectionIndex or detailIndex");
            return;
          }

          const updatedActions = Object.keys(point.actions).reduce(
            (newActions, action) => {
              newActions[action] = {
                ...point.actions[action],
                isSelected: false,
              };
              return newActions;
            },
            {} as Detail["actions"]
          );

          const updatedPoint = {
            ...point,
            answerValue: point.answerValue,
            isEditing: false,
            isCommenting: false,
            isCrossing: false,
            isChecking: false,
            isGalleryVisible: false,
            isSaving: false,
            actions: updatedActions,
            photos: [
              ...point.photos,
              ...compressedImages.map(({ uuid }) => ({
                url: "",
                uuid: uuid,
                type: "image",
              })),
            ],
          };

          // Update Redux state immediately
          if (workOrderId) {
            dispatch(
              updateInpectionPointAndStartWorkOrder({
                item_ID: asset_ID,
                updatePoint: { ...updatedPoint },
                sectionIndex,
                token,
                workorder_id: +workOrderId,
              })
            );
            dispatch(
              updateImageCount({
                asset_id: asset_ID,
                photosCount:
                  (itemDetail?.photosCount || 0) + selectedFiles.length,
                workOrder_ID: +workOrderId,
              })
            );
          }

          // Filter out UUIDs that already have URLs (already uploaded)
          // This prevents duplicate uploads on retry
          const existingPhotosWithUrls: Image[] = (point.photos || []).filter(
            (photo: Image) => photo.uuid && photo.url && photo.url.trim() !== ""
          );
          const existingUuids = new Set<string>(
            existingPhotosWithUrls.map((photo: Image) => photo.uuid!).filter(Boolean)
          );

          // Only queue UUIDs that don't already have URLs
          const uuidsToUpload = compressedImages
            .map(({ uuid }) => uuid)
            .filter((uuid) => !existingUuids.has(uuid));

          // If all photos already have URLs, skip queuing
          if (uuidsToUpload.length === 0) {
            console.log(
              "All photos already uploaded - skipping queue"
            );
            const isOnline = await isReallyOnline();
            dispatch(
              showToaster({
                message: isOnline
                  ? `All images already uploaded!`
                  : `Media saved offline!`,
                type: "success",
              })
            );
            setUploadedImage([]);
            setSelectedFiles([]);
            setIsUploadImageModal(false);
            return;
          }

          // Queue to service worker for background upload
          // Note: Service worker will get token from IndexedDB
          const tenantKey = await getIndexDBSettings("tenantKey") || "";
          await postMessage({
            type: "QUEUE_INSPECTION_POINT_MEDIA_BATCH",
            payload: {
              pointId: pointId,
              workOrderId: workOrderId ? parseInt(workOrderId) : null,
              assetId: asset_ID,
              sectionIndex: sectionIndex,
              detailIndex: detailIndex,
              uuids: uuidsToUpload, // Only upload UUIDs that don't have URLs yet
              displayOrderStart: !Number.isNaN(itemDetail?.photosCount)
                ? itemDetail?.photosCount || 1
                : 1,
              tenant: tenant,
              tenantKey: tenantKey,
            },
          });

          const isOnline = await isReallyOnline();
          dispatch(
            showToaster({
              message: isOnline
                ? `Images queued for upload!`
                : `Media saved offline!`,
              type: "success",
            })
          );

          // Trigger sync
          postMessage({
            type: "MANUAL_SYNC",
            payload: { message: "Hi from Manual Sync" },
          });

          setUploadedImage([]);
          setSelectedFiles([]);
          setIsUploadImageModal(false);
          console.log("Image upload process completed successfully");
        } catch (error) {
          console.error("Image upload failed:", error);
          dispatch(
            showToaster({
              message: "Failed to process images. Please try again.",
              type: "error",
            })
          );
        }
      } else {
        console.warn("No images selected.");
      }
    }
  };

  const handleUploadedVideoProceed = async () => {
    if (currentCapturedDetail) {
      const { sectionIndex, detailIndex, detail } = currentCapturedDetail;

      if (selectedFiles.length > 0) {
        try {
          for (const selectedFile of selectedFiles) {
            const fileName =
              generateGuid() +
              (selectedFile.type.includes("video")
                ? selectedFile.type.includes("quicktime")
                  ? ".mov"
                  : ".mp4"
                : ".jpeg");
            try {
              const presignedUrl = await dispatch(
                fetchPresignedUrl({ token, fileName })
              );
              if (presignedUrl.payload === "Network error") {
                throw new Error("Network error");
              }

              if (presignedUrl.meta.requestStatus === "fulfilled") {
                const { url } = presignedUrl.payload as { url: string };
                const tenantKey = await getIndexDBSettings("tenantKey") || "";
                const headers = new Headers();
                headers.append("Content-Type", selectedFile.type);
                headers.append("x-ms-blob-type", "BlockBlob");
                headers.append("x-ms-meta-Tenant", tenant);
                headers.append("x-ms-meta-PointID", detail.id);
                headers.append("x-ms-meta-TenantKey", tenantKey);
                const res = await fetch(url, {
                  method: "PUT",
                  body: selectedFile,
                  headers: Object.fromEntries(headers),
                });

                await res.text();

                await dispatch(
                  updatePhotoUrl({
                    token: token,
                    inspectionPointId: detail.id,
                    url: url.split("?")[0],
                    displayOrder: !Number.isNaN(itemDetail?.photosCount)
                      ? itemDetail?.photosCount || 1
                      : 1,
                  })
                );

                dispatch(
                  showToaster({
                    message: "Video uploaded successfully!",
                    type: "success",
                  })
                );
              } else {
                throw new Error("Presigned URL Failed");
              }
            } catch (error: any) {
              console.log("axios error", error);

              const isOffline = error?.message === "Network error";

              if (isOffline || error.name === "AbortError") {
                if (!isOfflineMode) {
                  turnOfflineModeOn();
                  dispatch(
                    showToaster({
                      message: `Poor connectivity! Switching to offline mode`,
                      type: "error",
                    })
                  );
                }
                const tenantKey = await getIndexDBSettings("tenantKey") || "";
                const headers = new Headers();
                headers.append("Content-Type", selectedFile.type);
                headers.append("x-ms-blob-type", "BlockBlob");
                headers.append("x-ms-meta-Tenant", tenant);
                headers.append("x-ms-meta-PointID", detail.id);
                headers.append("x-ms-meta-TenantKey", tenantKey);
                postMessage({
                  type: "PRESIGNED_URL_FAILED",
                  payload: {
                    message: "Hello Service Worker",
                    config: {
                      req: { token, fileName },
                      fileBase64: await uint8ArrayToBase64(
                        new Uint8Array(await selectedFile.arrayBuffer())
                      ),
                      file: selectedFile,
                      headers: Object.fromEntries(headers),
                      workOrderId: workOrderId ? parseInt(workOrderId) : null,
                      assetId: asset_ID,
                      pointId: detail.id,
                      type: "imageUpload",
                      displayOrder: !Number.isNaN(itemDetail?.photosCount)
                        ? itemDetail?.photosCount || 1
                        : 1,
                    },
                  },
                });
              }
            }
          }
          const section = itemDetail?.modules[sectionIndex];
          const point = section?.points[detailIndex];

          if (!section || !point) {
            console.error("Invalid sectionIndex or detailIndex");
            return;
          }
          const updatedActions = Object.keys(point.actions).reduce(
            (newActions, action) => {
              newActions[action] = {
                ...point.actions[action],
                isSelected: false,
              };
              return newActions;
            },
            {} as Detail["actions"]
          );

          const videoPromises = selectedFiles.map(async (video) => ({
            url: "",
            base64: URL.createObjectURL(video),
            type: "video",
          }));

          const newVideos = await Promise.all(videoPromises);

          const updatedPoint = {
            ...point,
            answerValue: point.answerValue,
            isEditing: false,
            isCommenting: false,
            isCrossing: false,
            isChecking: false,
            isGalleryVisible: false,
            isSaving: false,
            actions: updatedActions,
            photos: [...point.photos, ...newVideos],
          };

          if (workOrderId) {
            dispatch(
              updateInpectionPointAndStartWorkOrder({
                item_ID: asset_ID,
                updatePoint: { ...updatedPoint },
                sectionIndex,
                token,
                workorder_id: +workOrderId,
              })
            );
            dispatch(
              updateImageCount({
                asset_id: asset_ID,
                photosCount:
                  (itemDetail?.photosCount || 0) + selectedFiles.length,
                workOrder_ID: +workOrderId,
              })
            );
          }

          setUploadedVideo([]);
          setSelectedFiles([]);
          setIsUploadVideoModal(false);
        } catch (error) {
          console.error("Video upload failed:", error);
        }
      } else {
        alert("No videos selected.");
      }
    }
  };

  const { items } = useSelector(
    (state: RootState) => state.pendingUploadsQueue
  );
  const matchWorkOrderPending = items.some(
    (item: any) => item.workOrderId === workOrderId
  );

  const getSingleWorkOrderDetail = async () => {
    const isOnline = await isReallyOnline();
    if (isOnline && !matchWorkOrderPending) {
      try {
        if (workOrderId) {
          const resultAction = await dispatch(
            fetchWorkOrderDetails({ token, workorder_id: +workOrderId })
          );

          if (fetchWorkOrderDetails.fulfilled.match(resultAction)) {
          } else {
            console.log("Failed to fetch work order details");
          }
        }
      } catch (error) {
        console.log("Internal Server Error", error);
      }
    }
    if (matchWorkOrderPending) {
      dispatch(
        showToaster({
          message: `Pending sync, unable to refresh`,
          type: "success",
        })
      );
    }
  };

  const handleCloseSkipModuleModal = () => {
    setIsSkipModuleModalOpen(false);
    setSelectedModule(null);
    setSelectedModuleIndex(null);
  };

  const handleCloseUnSkipModuleModal = () => {
    setIsUnSkipModuleModalOpen(false);
    setSelectedModule(null);
    setSelectedModuleIndex(null);
  };

  const handleOpenSkipModuleModal = (module: Section, moduleIndex: number) => {
    setSelectedModule(module);
    setSelectedModuleIndex(moduleIndex);
    setIsSkipModuleModalOpen(true);
  };

  const handleOpenUnSkipModuleModal = (
    module: Section,
    moduleIndex: number
  ) => {
    setSelectedModule(module);
    setSelectedModuleIndex(moduleIndex);
    setIsUnSkipModuleModalOpen(true);
  };

  const handleSkipUnSkipModule = async (
    module: Section,
    moduleIndex: number
  ) => {
    try {
      if (module.isSkipped) {
        await handleUnskipAll(moduleIndex);
      } else {
        await handleSkipAll(moduleIndex);
      }

      if (module.isSkipped) {
        handleCloseUnSkipModuleModal();
      } else {
        handleCloseSkipModuleModal();
      }

      dispatch(
        showToaster({
          message: `Module ${module.isSkipped ? "Unskipped!" : "Skipped!"}`,
          type: "success",
        })
      );
    } catch (error) {
      dispatch(
        showToaster({
          message: `Failed to ${
            module.isSkipped ? "unskip" : "skip"
          } the module!`,
          type: "error",
        })
      );
      console.error("Error while skipping/unskipping module:", error);
    }
  };
  const handleCrossValueChange = (pointId: number, value: string) => {
    setCrossValues((prev) => ({
      ...prev,
      [pointId]: value,
    }));
  };

  const resetCrossValue = (pointId: number) => {
    setCrossValues((prev) => {
      const updated = { ...prev };
      delete updated[pointId];
      return updated;
    });
  };

  const handleAnswerValueChange = (pointId: number, value: string) => {
    setAnswerInputValues((prev) => ({
      ...prev,
      [pointId]: value,
    }));
  };

  return (
    <>
      <PullToRefresh
        onRefresh={getSingleWorkOrderDetail}
        isPullable={!isUploadImageModal}
        refreshingContent={
          <div className="flex justify-center items-center mt-4">
            <div className="w-8 h-8 border-4 border-t-transparent border-blue-500 rounded-full animate-spin"></div>
          </div>
        }
      >
        <div className="min-h-screen flex flex-col bg-white">
          <Layout title="Inspection Points" showBackIcon={true} navigateTo={`/work-orders/${workOrderId}`}>
            <div className="p-4 bg-gray-100 min-h-screen">
              <div className="bg-primary text-white py-4 px-2 rounded-t-2xl shadow-md">
                <div className="relative flex-col justify-between items-start">
                  <div className="flex flex-col gap-2">
                    <p className="text-sm font-bold">
                      {itemDetail?.description || "-"}
                    </p>
                    <p className="text-xs">
                      ITEM ID:{" "}
                      {itemDetail?.item_ID.toString().length === 13
                        ? "Pending"
                        : itemDetail?.item_ID}
                    </p>
                    <p className="text-xs">
                      STOCK #: {itemDetail?.stockNumber || "-"}
                    </p>
                    <p className="text-xs">SN/VIN: {itemDetail?.vin || "-"}</p>
                  </div>
                  <div className="right-0 w-max mt-2 bg-orange-400 px-2 py-1 rounded-full text-xs font-bold flex items-center">
                    <img src={ASSET_PATHS.tablerProgressWhite} alt="Progress" />
                    <span className="ml-1">{`Total Points (${Math.min(
                      itemDetail?.totalVerified || 0,
                      itemDetail?.totalSumOfPoints || 0
                    )}/${itemDetail?.totalSumOfPoints})`}</span>
                  </div>
                </div>
              </div>
              <div className="border border-border px-2 pb-8 rounded-b-2xl bg-gray-50 min-h-screen">
                <div className="flex-grow px-2 space-y-4 pb-3">
                  {itemDetail && itemDetail?.modules?.length > 0 ? (
                    itemDetail?.modules?.map(
                      (section: Section, index: number) => {
                        return (
                          <SwipeableModuleContainer
                            key={index}
                            index={index}
                            isActive={showIcons[index]}
                            setShowIcons={setShowIcons}
                            workOrderStatus={
                              workOrderDetail[+workOrderId!].workOrderStatus
                            }
                          >
                            <div
                              className={`swipe-allowed ${
                                section.total > section.totalVerified
                                  ? "bg-gray-200"
                                  : "bg-green-100 border-2 border-green-500"
                              } px-4 py-3 rounded-md mt-4 flex justify-between items-center cursor-pointer`}
                              onClick={() => toggleSection(index)}
                            >
                              <div className="flex items-center gap-2">
                                {section.total > section.totalVerified ? (
                                  <img
                                    src={ASSET_PATHS.tablerProgress}
                                    alt="Progress"
                                  />
                                ) : (
                                  <img
                                    src={ASSET_PATHS.checkCircle2}
                                    alt="Progress"
                                  />
                                )}

                                <div className="flex items-center gap-2">
                                  <span className="text-[10px] mt-[2.3px] text-center font-normal align-middle flex justify-center items-center">
                                    {section.totalVerified > section.total
                                      ? section.total
                                      : section.totalVerified}
                                    /{section.total}
                                  </span>
                                  <span className="text-sm font-semibold">
                                    {section.title}
                                  </span>
                                </div>
                                {showIcons[index] && (
                                  <div className="absolute right-[-43px] top-6 transform -translate-y-1/2 flex items-center">
                                    <img
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        if (!section.isSkipped) {
                                          handleOpenSkipModuleModal(
                                            section,
                                            index
                                          );
                                        } else {
                                          handleOpenUnSkipModuleModal(
                                            section,
                                            index
                                          );
                                        }
                                      }}
                                      src={
                                        !section.isSkipped
                                          ? ASSET_PATHS.blockIconModule
                                          : ASSET_PATHS.unSkip
                                      }
                                      alt="Block Icon"
                                      className="h-8 w-8"
                                    />
                                  </div>
                                )}
                              </div>
                              {section.isOpen ? (
                                <IoIosArrowUp />
                              ) : (
                                <IoIosArrowDown />
                              )}
                            </div>
                            <div
                              ref={(el) => (contentRefs.current[index] = el)}
                              className="transition-all duration-300 ease-in-out overflow-hidden max-h-[100%]"
                            >
                              {section?.points
                                ?.filter((x) =>
                                  itemDetail.type === 2
                                    ? ![
                                        PointType.Year,
                                        PointType.Make,
                                        PointType.Model,
                                      ].includes(x.verifyField_ID)
                                    : true
                                )
                                .map((detail: Detail, detailIndex: number) => (
                                  <div
                                    key={detailIndex}
                                    className={`border rounded-lg items-center justify-between mt-3 bg-white`}
                                  >
                                    <div
                                      className={`bg-gray-200 flex items-center justify-between p-3 rounded-t-md ${
                                        detail.isCompleted &&
                                        "border-l-4 border-green-500"
                                      }`}
                                    >
                                      <span className="font-semibold text-xs">
                                        {detail.label}
                                      </span>
                                      <span className="font-medium text-sm">
                                        {detail.notApplicable
                                          ? "N/A"
                                          : detail.type_ID == 5 ||
                                            detail.type_ID == 4
                                          ? detail.answerDisplay
                                            ? detail.answerDisplay
                                            : detail.verify
                                          : detail.answerValue}
                                      </span>
                                    </div>
                                    {!detail.notApplicable && (
                                      <div
                                        className={`flex items-center space-x-2 justify-evenly py-2 `}
                                      >
                                        {detail?.actions?.check?.enabled && (
                                          <button
                                            className={`p-1 'bg-white'}`}
                                            onClick={() =>
                                              handleCheck({
                                                sectionIndex: index,
                                                detailIndex,
                                                pointId: detail?.id,
                                              })
                                            }
                                          >
                                            {(detail.type_ID == 4 ||
                                              detail.type_ID == 5) &&
                                            detail.answerValue == "YES" ? (
                                              <img
                                                src={
                                                  ASSET_PATHS.checkCircleGreen
                                                }
                                                alt="Check"
                                              />
                                            ) : (
                                              <img
                                                src={
                                                  ASSET_PATHS.checkCircleGrey
                                                }
                                                alt="Check"
                                              />
                                            )}
                                          </button>
                                        )}
                                        {detail?.actions?.cross?.enabled && (
                                          <button
                                            className={`p-1 ${
                                              detail.actions.cross.isSelected &&
                                              detail.type_ID == 5
                                                ? "bg-primary"
                                                : "bg-white"
                                            }`}
                                            onClick={() => {
                                              if (detail.type_ID == 5)
                                                toggleCross(index, detailIndex);
                                              else
                                                handleCross({
                                                  sectionIndex: index,
                                                  detailIndex,
                                                  pointId: detail?.id,
                                                });
                                            }}
                                          >
                                            {detail.type_ID == 5 &&
                                            detail.answerValue == "NO" &&
                                            !detail.actions.cross.isSelected ? (
                                              <img
                                                src={ASSET_PATHS.editBlue}
                                                alt="Cross"
                                              />
                                            ) : detail.type_ID == 4 &&
                                              detail.answerValue == "NO" ? (
                                              <img
                                                src={ASSET_PATHS.blueCrossIcon}
                                                alt="Cross"
                                              />
                                            ) : detail.actions.cross
                                                .isSelected &&
                                              detail.type_ID != 4 ? (
                                              <img
                                                src={ASSET_PATHS.editWhite}
                                                alt="Cross"
                                              />
                                            ) : !detail.actions.cross
                                                .isSelected &&
                                              detail.type_ID != 4 ? (
                                              <img
                                                src={ASSET_PATHS.edit}
                                                alt="Cross"
                                              />
                                            ) : (
                                              <img
                                                src={ASSET_PATHS.xCircle}
                                                alt="Cross"
                                              />
                                            )}
                                          </button>
                                        )}
                                        {detail?.actions?.edit?.enabled && (
                                          <button
                                            className={`p-1 ${
                                              detail.actions.edit.isSelected
                                                ? "bg-primary"
                                                : "bg-white"
                                            }`}
                                            onClick={() => {
                                              toggleEdit(index, detailIndex);
                                            }}
                                          >
                                            {detail.actions.edit.isSelected ? (
                                              <img
                                                src={ASSET_PATHS.editWhite}
                                                alt="Edit"
                                              />
                                            ) : (detail.type_ID == 1 ||
                                                detail.type_ID == 3) &&
                                              detail.answerValue ? (
                                              <img
                                                src={ASSET_PATHS.editBlue}
                                                alt="Edit"
                                              />
                                            ) : (
                                              <img
                                                src={ASSET_PATHS.edit}
                                                alt="Edit"
                                              />
                                            )}
                                          </button>
                                        )}
                                        {detail?.actions?.camera?.enabled && (
                                          <>
                                            <label
                                              htmlFor={`file-upload-${index}`}
                                              className={`cursor-pointer ${
                                                detail.actions.camera.isSelected
                                                  ? "bg-primary"
                                                  : "bg-white"
                                              }`}
                                              onClick={() =>
                                                openModal(
                                                  `file-upload-${index}-${detailIndex}`
                                                )
                                              }
                                            >
                                              {detail.actions.camera
                                                .isSelected ? (
                                                <img
                                                  src={ASSET_PATHS.cameraWhite}
                                                  alt="Camera"
                                                />
                                              ) : (
                                                <img
                                                  src={ASSET_PATHS.camera}
                                                  alt="Camera"
                                                />
                                              )}
                                            </label>
                                            <input
                                              id={`file-upload-${index}-${detailIndex}`}
                                              type="file"
                                              accept="image/*"
                                              multiple={true}
                                              className="hidden"
                                              capture={
                                                isCameraSelected && isAndroid
                                                  ? "environment"
                                                  : undefined
                                              }
                                              onClick={(
                                                e: React.MouseEvent<HTMLInputElement>
                                              ) => {
                                                e.currentTarget.value = "";
                                              }}
                                              onChange={async (
                                                event: React.ChangeEvent<HTMLInputElement>
                                              ) => {
                                                await handleFileUpload(
                                                  event,
                                                  "image"
                                                );
                                                setCurrentCapturedDetail({
                                                  sectionIndex: index,
                                                  detailIndex,
                                                  detail,
                                                });
                                              }}
                                              disabled={
                                                workOrderDetail[+workOrderId!]
                                                  .workOrderStatus ===
                                                WorkOrderStatus.Completed
                                              }
                                            />
                                          </>
                                        )}
                                        {detail?.actions?.video?.enabled && (
                                          <>
                                            <label
                                              htmlFor={`video-upload-${index}-${detailIndex}`}
                                              className={`cursor-pointer ${
                                                detail?.actions?.video
                                                  ?.isSelected
                                                  ? "bg-primary"
                                                  : "bg-white"
                                              }`}
                                              onClick={async (e) => {
                                                const isOnline =
                                                  await isReallyOnline();

                                                if (!isOnline) {
                                                  e.preventDefault();
                                                  dispatch(
                                                    showToaster({
                                                      message:
                                                        "You're offline. Cannot upload video.",
                                                      type: "error",
                                                    })
                                                  );
                                                }
                                              }}
                                            >
                                              {detail?.actions?.video
                                                ?.isSelected ? (
                                                <img
                                                  src={ASSET_PATHS?.videoWhite}
                                                  alt="Video"
                                                />
                                              ) : (
                                                <img
                                                  src={ASSET_PATHS?.video}
                                                  alt="Video"
                                                />
                                              )}
                                            </label>
                                            <input
                                              id={`video-upload-${index}-${detailIndex}`}
                                              type="file"
                                              accept="video/*"
                                              multiple={true}
                                              // capture="environment"
                                              className="hidden"
                                              onClick={(
                                                e: React.MouseEvent<HTMLInputElement>
                                              ) => {
                                                e.currentTarget.value = "";
                                              }}
                                              onChange={async (
                                                event: React.ChangeEvent<HTMLInputElement>
                                              ) => {
                                                await handleFileUpload(
                                                  event,
                                                  "video"
                                                );
                                                setCurrentCapturedDetail({
                                                  sectionIndex: index,
                                                  detailIndex,
                                                  detail,
                                                });
                                              }}
                                              disabled={
                                                workOrderDetail[+workOrderId!]
                                                  .workOrderStatus ===
                                                WorkOrderStatus.Completed
                                              }
                                            />
                                          </>
                                        )}
                                        {detail?.actions?.gallery?.enabled && (
                                          <button
                                            className={`p-1 ${
                                              detail.actions.gallery.isSelected
                                                ? "bg-primary"
                                                : "bg-white"
                                            }`}
                                            onClick={() => {
                                              toggleGallery(index, detailIndex);
                                            }}
                                          >
                                            {detail.actions.gallery
                                              .isSelected ? (
                                              <img
                                                src={
                                                  ASSET_PATHS.photographWhiteIcon
                                                }
                                                alt="gallery"
                                              />
                                            ) : (detail.photoOption_ID == 1 ||
                                                detail.photoOption_ID == 2 ||
                                                detail.videoOption_ID == 1 ||
                                                detail.videoOption_ID == 2) &&
                                              detail?.photos?.length > 0 ? (
                                              <img
                                                src={
                                                  ASSET_PATHS.bluePhotographIcon
                                                }
                                                alt="gallery"
                                              />
                                            ) : (
                                              <img
                                                src={ASSET_PATHS.photograph}
                                                alt="gallery"
                                              />
                                            )}
                                          </button>
                                        )}
                                        {detail?.actions?.trash?.enabled && (
                                          <button
                                            className={`p-1 bg-white`}
                                            onClick={() => {
                                              handleSkip(index, detail);
                                            }}
                                            onError={async (e) => {
                                              const videoElement =
                                                e.target as HTMLVideoElement;
                                              videoElement.poster =
                                                ASSET_PATHS.poster;
                                              const isOnline =
                                                await isReallyOnline();
                                              if (!isOnline)
                                                videoElement.src = "";
                                            }}
                                          >
                                            <img
                                              src={ASSET_PATHS.skipGrey}
                                              alt="trash"
                                            />
                                          </button>
                                        )}
                                      </div>
                                    )}
                                    {detail?.notApplicable && (
                                      <button
                                        className="flex justify-center items-center p-2 cursor-pointer mx-auto"
                                        onClick={() => {
                                          handleUnSkip(index, detail);
                                        }}
                                      >
                                        <img
                                          src={ASSET_PATHS.unSkip}
                                          alt="Not Acceptable"
                                        />
                                      </button>
                                    )}

                                    <div>
                                      {detail?.isEditing && (
                                        <div className="flex-col items-center gap-2 p-2">
                                          <label className="text-xs">
                                            Enter
                                          </label>

                                          <AutoResizeTextarea
                                            value={
                                              answerInputValues[detail.id] || ""
                                            }
                                            onChange={(val: any) =>
                                              handleAnswerValueChange(
                                                detail.id,
                                                val
                                              )
                                            }
                                            placeholder="e.g. 12"
                                          />
                                          {(() => {
                                            const inputLength =
                                              answerInputValues[detail.id]
                                                ?.length;
                                            const { limit, errorMessage } = getInspectionPointLimit(detail);
                                            return inputLength > limit ? (
                                              <p className="text-red-500 text-xs mt-1">
                                                {errorMessage}
                                              </p>
                                            ) : null;
                                          })()}

                                          <div className="flex gap-2 mt-4 w-full">
                                            <button
                                              className="w-full py-1 rounded-lg font-semibold border-2 text-success border-success"
                                              onClick={() =>
                                                toggleEdit(index, detailIndex)
                                              }
                                            >
                                              Cancel
                                            </button>
                                            <button
                                              className={`bg-primary text-white w-full py-1 rounded-lg font-semibold 
                                                                                            ${
                                                                                              !answerInputValues[
                                                                                                detail.id
                                                                                              ] ||
                                                                                              answerInputValues[detail.id]?.length > getInspectionPointLimit(detail).limit
                                                                                                ? "opacity-50 cursor-not-allowed"
                                                                                                : ""
                                                                                            }`}
                                              onClick={() =>
                                                handleSave({
                                                  sectionIndex: index,
                                                  detailIndex,
                                                  pointId: detail?.id,
                                                  type: "edit",
                                                })
                                              }
                                              disabled={
                                                !answerInputValues[detail.id] ||
                                                detail.isSaving ||
                                                answerInputValues[detail.id]?.length > getInspectionPointLimit(detail).limit
                                              }
                                            >
                                              {detail.isSaving ? (
                                                <div className="py-1 flex justify-center">
                                                  <ImSpinner2 className="animate-spin mr-2" />
                                                </div>
                                              ) : (
                                                "Save"
                                              )}
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                      {detail?.isCommenting && (
                                        <div className="flex-col items-center gap-2 p-2">
                                          <label className="text-xs">
                                            Comment
                                          </label>
                                          <AutoResizeTextarea
                                            value={commentValue || ""}
                                            onChange={(val) =>
                                              setCommentValue(val)
                                            }
                                            placeholder="e.g. 12"
                                          />
                                          <div className="flex gap-2 mt-4 w-full">
                                            <button
                                              className="w-full py-1 rounded-lg font-semibold border-2 text-success border-success"
                                              onClick={() => {
                                                toggleComment(
                                                  index,
                                                  detailIndex
                                                );
                                              }}
                                            >
                                              Cancel
                                            </button>
                                            <button
                                              className="bg-primary text-white w-full py-1 rounded-lg font-semibold"
                                              onClick={() =>
                                                handleSave({
                                                  sectionIndex: index,
                                                  detailIndex,
                                                  pointId: detail?.id,
                                                  type: "comment",
                                                })
                                              }
                                            >
                                              {detail.isSaving ? (
                                                <div className="py-1 flex justify-center">
                                                  <ImSpinner2 className="animate-spin mr-2" />
                                                </div>
                                              ) : (
                                                "Save"
                                              )}
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                      {detail?.isCrossing && (
                                        <div className="flex-col items-center gap-2 p-2">
                                          <label className="text-xs">
                                            Enter Correct Value
                                          </label>
                                          <AutoResizeTextarea
                                            value={crossValues[detail.id] || ""}
                                            onChange={(val) => {
                                              handleCrossValueChange(
                                                detail.id,
                                                val
                                              );
                                            }}
                                            placeholder="Enter value"
                                          />
                                          {(() => {
                                            const inputLength =
                                              crossValues[detail.id]?.length;
                                            const { limit, errorMessage } = getInspectionPointLimit(detail);
                                            return inputLength > limit ? (
                                              <p className="text-red-500 text-xs mt-1">
                                                {errorMessage}
                                              </p>
                                            ) : null;
                                          })()}
                                          <div className="flex gap-2 mt-4 w-full">
                                            <button
                                              className="w-full py-1 rounded-lg font-semibold border-2 text-success border-success"
                                              onClick={() =>
                                                handleCancel(
                                                  index,
                                                  detailIndex,
                                                  "cancel"
                                                )
                                              }
                                            >
                                              Cancel
                                            </button>

                                            <button
                                              className={`bg-primary text-white w-full py-1 rounded-lg font-semibold 
                                                                                            ${
                                                                                              !crossValues[
                                                                                                detail.id
                                                                                              ] ||
                                                                                              crossValues[detail.id]?.length > getInspectionPointLimit(detail).limit
                                                                                                ? "opacity-50 cursor-not-allowed"
                                                                                                : ""
                                                                                            }`}
                                              onClick={() =>
                                                handleSave({
                                                  sectionIndex: index,
                                                  detailIndex,
                                                  pointId: detail?.id,
                                                  type: "cross",
                                                })
                                              }
                                              disabled={
                                                !crossValues[detail.id] ||
                                                detail.isSaving ||
                                                crossValues[detail.id]?.length > getInspectionPointLimit(detail).limit
                                              }
                                            >
                                              {detail.isSaving ? (
                                                <div className="py-1 flex justify-center">
                                                  <ImSpinner2 className="animate-spin mr-2" />
                                                </div>
                                              ) : (
                                                "Save"
                                              )}
                                            </button>
                                          </div>
                                        </div>
                                      )}

                                      {detail?.isGalleryVisible ? (
                                        detail?.photos?.length > 0 ? (
                                          <div>
                                            <div className="flex overflow-x-auto gap-2 p-2 max-w-full max-h-[400px]">
                                              {detail?.photos?.map(
                                                (media, mediaIndex) => (
                                                  <div
                                                    key={mediaIndex}
                                                    className="flex-none w-1/3 p-1"
                                                    style={{
                                                      aspectRatio: "1 / 1",
                                                      maxWidth: "150px",
                                                      maxHeight: "150px",
                                                    }}
                                                  >
                                                    {media.type === "image" ? (
                                                      <div className="relative w-full h-full">
                                                        <img
                                                          src={
                                                            media.uuid
                                                              ? resolvedImageURLs[
                                                                  media.uuid
                                                                ]
                                                              : media.url
                                                          }
                                                          alt={`Gallery ${mediaIndex}`}
                                                          className="w-full h-full object-cover rounded-md cursor-pointer"
                                                          onClick={() =>
                                                            openPreviewModal(
                                                              [
                                                                ...detail?.photos,
                                                              ],
                                                              mediaIndex
                                                            )
                                                          }
                                                        />
                                                        {items.some(
                                                          (item: any) =>
                                                            item?.pointId ===
                                                              detail?.id &&
                                                            (item?.assetId ===
                                                              itemDetail?.item_ID ||
                                                              item?.assetId ===
                                                                itemDetail?.id) &&
                                                            item?.base64 &&
                                                            item?.base64 ===
                                                              media.uuid
                                                        ) && (
                                                          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-md">
                                                            <span className="text-white text-lg font-semibold">
                                                              Pending
                                                            </span>
                                                          </div>
                                                        )}
                                                      </div>
                                                    ) : (
                                                      <video
                                                        src={
                                                          media.base64 ||
                                                          media.url + "#t=0.001"
                                                        }
                                                        className="w-full h-full object-cover rounded-md cursor-pointer"
                                                        preload={
                                                          isSafari &&
                                                          media.base64
                                                            ? "none"
                                                            : "metadata"
                                                        }
                                                        poster={
                                                          isSafari &&
                                                          media.base64
                                                            ? ASSET_PATHS.poster
                                                            : ""
                                                        }
                                                        controls={false}
                                                        onClick={async (e) => {
                                                          const isOnline =
                                                            await isReallyOnline();
                                                          if (!isOnline) {
                                                            e.preventDefault();
                                                            dispatch(
                                                              showToaster({
                                                                message:
                                                                  "You're offline. Cannot display video.",
                                                                type: "error",
                                                              })
                                                            );
                                                          } else {
                                                            openPreviewModal(
                                                              [
                                                                ...detail?.photos,
                                                              ],
                                                              mediaIndex
                                                            );
                                                          }
                                                        }}
                                                        onError={async (e) => {
                                                          const isOnline =
                                                            await isReallyOnline();
                                                          const videoElement =
                                                            e.target as HTMLVideoElement;
                                                          videoElement.poster =
                                                            ASSET_PATHS.poster;
                                                          if (!isOnline)
                                                            videoElement.src =
                                                              "";
                                                        }}
                                                      ></video>
                                                    )}
                                                  </div>
                                                )
                                              )}
                                            </div>
                                          </div>
                                        ) : (
                                          <p className="text-center text-sm text-gray-500 mt-3 mb-3">
                                            No photos found
                                          </p>
                                        )
                                      ) : null}
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </SwipeableModuleContainer>
                        );
                      }
                    )
                  ) : (
                    <p className="text-center text-gray-500 mt-5">
                      No Inpection Points found
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* {
                    showSkipModal && (
                        <BlockConfirmationModal
                            isOpen={showSkipModal}
                            onClose={handleCloseSkipModal}
                            onConfirm={handleSkip}
                        />
                    )
                } */}

            {uploadedImage && (
              <PreviewImageUploadModal
                isOpen={isUploadImageModal}
                onClose={() => handleCloseUploadImageModal(true)}
                onConfirm={handleUploadedImageProceed}
                uploadedImage={uploadedImage}
                openGallery={handleFileUpload}
                setCurrentCapturedDetail={setCurrentCapturedDetail}
                workOrderDetail={workOrderDetail}
                workOrderId={workOrderId}
                handleRemoveImage={handleRemoveImage}
                onAddMoreClick={() => {
                  // handleCloseUploadImageModal(false);
                  openModal(elementControlId);
                }}
              />
            )}
            {uploadedVideo && (
              <PreviewVideoUploadModal
                isOpen={isUploadVideoModal}
                onClose={handleCloseUploadVideoModal}
                onConfirm={handleUploadedVideoProceed}
                uploadedVideo={uploadedVideo}
                openGallery={handleFileUpload}
                setCurrentCapturedDetail={setCurrentCapturedDetail}
                workOrderDetail={workOrderDetail}
                workOrderId={workOrderId}
              />
            )}

            {isPreviewModalOpen && (
              <div className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center">
                <button
                  className="absolute top-4 right-4 p-1 bg-white rounded-full z-10"
                  onClick={handleClosePreviewModal}
                >
                  <IoIosClose size={24} />
                </button>

                <div
                  ref={modalRef}
                  className="relative w-full max-w-md md:max-w-screen-md p-4 flex items-center justify-center"
                >
                  <button
                    className="absolute top-1/2 left-2 transform -translate-y-1/2 p-2 bg-white rounded-full z-10"
                    onClick={handlePrevImage}
                  >
                    <IoIosArrowBack />
                  </button>

                  {currentImages[currentImageIndex].type === "video" ? (
                    <video
                      src={
                        currentImages[currentImageIndex].base64 ||
                        currentImages[currentImageIndex].url + "#t=0.001"
                      }
                      className="object-contain w-full h-auto max-h-[80vh] max-w-[90vw]"
                      preload={
                        isSafari && currentImages[currentImageIndex].base64
                          ? "none"
                          : "metadata"
                      }
                      poster={
                        isSafari && currentImages[currentImageIndex].base64
                          ? ASSET_PATHS.poster
                          : ""
                      }
                      controls
                    />
                  ) : (
                    <img
                      src={
                        currentImages[currentImageIndex].uuid
                          ? resolvedImageURLs[
                              currentImages[currentImageIndex].uuid
                            ]
                          : currentImages[currentImageIndex].url
                      }
                      alt="Preview"
                      className="object-contain w-full h-auto max-h-[80vh] max-w-[90vw]"
                    />
                  )}

                  <button
                    className="absolute top-1/2 right-2 transform -translate-y-1/2 p-2 bg-white rounded-full z-10"
                    onClick={handleNextImage}
                  >
                    <IoIosArrowForward />
                  </button>
                </div>
              </div>
            )}
          </Layout>
        </div>
      </PullToRefresh>
      {/* Modal for Camera or Gallery selection */}
      {isModalOpen && isAndroid && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
          onClick={closeModal}
        >
          <div
            className="bg-white rounded-lg shadow-lg w-11/12 max-w-sm text-center"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="py-4 border-b">
              <h2 className="text-lg font-medium">Choose Option</h2>
            </div>
            <div className="flex flex-col items-center py-4 space-y-3">
              <button
                onClick={() => {
                  setIsCameraSelected(true);
                  setShouldTriggerImageUpload(true);
                  closeModal();
                }}
                className="flex items-center justify-center bg-gray-100 rounded-lg w-10/12 p-3"
              >
                <img
                  src={ASSET_PATHS.camera}
                  alt="Camera"
                  className="w-6 h-6 mr-2"
                />
                <span className="text-base text-gray-700">Take Photo</span>
              </button>
              <button
                onClick={() => {
                  setIsCameraSelected(false);
                  setShouldTriggerImageUpload(true);
                  closeModal();
                }}
                className="flex items-center justify-center bg-gray-100 rounded-lg w-10/12 p-3"
              >
                <img
                  src={ASSET_PATHS.blackGalleryIcon}
                  alt="Gallery"
                  className="w-6 h-6 mr-2"
                />
                <span className="text-base text-gray-700">Photo Library</span>
              </button>
            </div>
          </div>
        </div>
      )}

      {isSkipModuleModalOpen &&
        selectedModule &&
        selectedModuleIndex !== null && (
          <SkipModuleModal
            isOpen={isSkipModuleModalOpen}
            onClose={handleCloseSkipModuleModal}
            onConfirm={handleSkipUnSkipModule}
            module={selectedModule}
            moduleIndex={selectedModuleIndex}
          />
        )}

      {isUnSkipModuleModalOpen &&
        selectedModule &&
        selectedModuleIndex !== null && (
          <UnSkipModuleModal
            isOpen={isUnSkipModuleModalOpen}
            onClose={handleCloseUnSkipModuleModal}
            onConfirm={handleSkipUnSkipModule}
            module={selectedModule}
            moduleIndex={selectedModuleIndex}
          />
        )}
    </>
  );
};

export default InspectionPoints;
